import React from "react";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { customClasses } from "../../../Styles/customClasses";
import { FormRadio, FormError } from "../../../Components/Basic";
import { LM } from "../../../Components/LM";
import leftShape from "../../../Assets/right-square-shape.png";

// schema
const qualifySchema = yup.object().shape({
  separated_12m: yup.string().required("This is required").nullable(),
  marriage_over: yup.string().required("This is required").nullable(),
  aust_citizen_requirement: yup
    .string()
    .required("This is required")
    .nullable(),
  aust_live_indefinitely_requirement: yup
    .string()
    .when("aust_citizen_requirement", (aust_citizen_requirement) => {
      if (aust_citizen_requirement === "No")
        return yup.string().required("This is required").nullable();
    }),
  aust_live_12m_requirement: yup
    .string()
    .when(
      "aust_live_indefinitely_requirement",
      (aust_live_indefinitely_requirement) => {
        if (aust_live_indefinitely_requirement === "No")
          return yup.string().required("This is required").nullable();
      }
    ),
});

function Qualify({ onSubmit, store }) {
  const {
    watch,
    setValue,
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(qualifySchema),
  });

  return (
    <form id="divorce-form" onSubmit={handleSubmit(onSubmit)}>
      <section className=" mx-auto w-5/6 md:w-2/3 lg:w-1/2 xl:w-1/3 pt-16">
        <p className={customClasses.questionText}>
          Have you been separated for 12 months?
        </p>

        <LM>
          <p className={customClasses.helperText}>
            Separation simply means that your relationship is over for good and
            you’re no longer a romantic couple.
          </p>
          <p className={customClasses.helperText}>
            To make a separation legal one person just needs to tell the other
            the relationship is over for good.
          </p>
          <p className={customClasses.helperText}>
            You can be separated and still live together.
          </p>
          <p className={customClasses.helperTextBold}>On and Off Again?</p>

          <p className={customClasses.helperText}>
            Did you separate and get back together for a short-time?
          </p>
          <p className={customClasses.helperText}>
            If you reconciled and lived together for less than 3 months, you can
            count the time before and after your reconciliation when working out
            if you’ve been separated for 12 months or more.
          </p>
          <p className={customClasses.helperText}>
            If you reconciled and lived together for more than 3 months, then
            generally speaking, you’ll need to re-start counting from the date
            you separated last.
          </p>
        </LM>
        <FormRadio
          register={register}
          name={"separated_12m"}
          setValue={setValue}
          value="Yes"
        />
        <FormRadio
          register={register}
          name={"separated_12m"}
          setValue={setValue}
          value="No"
        />
        <FormError error={errors.separated_12m?.message} />

        <p className={customClasses.questionText}>
          Is your marriage over for good?
        </p>
        <LM>
          <p className={customClasses.helperText}>
            Your marriage is over if there is no reasonable likelihood of
            resuming married life again with your spouse.
          </p>
        </LM>

        <FormRadio
          register={register}
          name={"marriage_over"}
          setValue={setValue}
          value="Yes"
        />
        <FormRadio
          register={register}
          name={"marriage_over"}
          setValue={setValue}
          value="No"
        />
        <FormError error={errors.marriage_over?.message} />

        <p className={customClasses.questionText}>
          Are either you or your spouse an Australian citizen?
        </p>
        <FormRadio
          register={register}
          name={"aust_citizen_requirement"}
          setValue={setValue}
          value="Yes"
        />
        <FormRadio
          register={register}
          name={"aust_citizen_requirement"}
          setValue={setValue}
          value="No"
        />
        <FormError error={errors.aust_citizen_requirement?.message} />

        {watch("aust_citizen_requirement") === "No" ? (
          <>
            <p className={customClasses.questionText}>
              Do at least one of you regard Australia as your home and intend to
              live in Australia indefinitely?
            </p>
            <FormRadio
              register={register}
              name={"aust_live_indefinitely_requirement"}
              setValue={setValue}
              value="Yes"
            />
            <FormRadio
              register={register}
              name={"aust_live_indefinitely_requirement"}
              setValue={setValue}
              value="No"
            />
            <FormError
              error={errors.aust_live_indefinitely_requirement?.message}
            />
          </>
        ) : null}

        {watch("aust_live_indefinitely_requirement") === "No" &&
          watch("aust_citizen_requirement") === "No" && (
            <>
              <p className={customClasses.questionText}>
                Do at least one of you ordinarily live in Australia and have
                done so for 12 months immediately before filing for divorce?
              </p>
              <FormRadio
                register={register}
                name={"aust_live_12m_requirement"}
                setValue={setValue}
                value="Yes"
              />
              <FormRadio
                register={register}
                name={"aust_live_12m_requirement"}
                setValue={setValue}
                value="No"
              />
              <FormError error={errors.aust_live_12m_requirement?.message} />
            </>
          )}
      </section>
      {/* blue size shape */}

      <section>
        <img
          className="invisible md:visible w-1/6 absolute top-40 right-0 ml-10"
          src={leftShape}
          alt="shape"
        />
      </section>
    </form>
  );
}

export default Qualify;
